import React from "react";
import { useServices } from "@/services-context";
import classNames from "classnames";
import styles from "./fix-breadcrumb.module.scss";
import { Icon } from "@/elements-react/fix-icon";
import separator from "@/assets/separator.svg";
import { useEffect, useMemo } from "preact/hooks";
import { PageTags } from "../document-elements/page-tags";

export interface Breadcrumb {
  url: string;
  label: string;
}

export const FixBreadcrumb: React.FC = () => {
  const services = useServices(["breadcrumbs"]);
  const breadcrumbs: Breadcrumb[] = services?.breadcrumbs?.breadcrumbs || [];
  const jsonLdDataset = useMemo(() => {
    return {
      breadcrumbs: breadcrumbs.map((item) => ({ name: item.label, url: item.url })),
    };
  }, [breadcrumbs]);

  return (
    <>
      <nav className={styles.root} aria-label="Breadcrumb">
        <ol className={styles.breadcrumbList}>
          {breadcrumbs.map((item, idx) => (
            <li
              className={classNames(styles.breadcrumbItem, {
                [styles.breadcrumbItemLast]: idx === breadcrumbs.length - 1,
              })}
            >
              <a href={item.url}>{item.label}</a>
              {breadcrumbs.length - 1 > idx && <Icon src={separator} className={styles.separator} />}
            </li>
          ))}
        </ol>
      </nav>
      <PageTags jsonld={jsonLdDataset} />
    </>
  );
};

export default FixBreadcrumb;

export const useBreadcrumbs = (breadcrumbs: Breadcrumb[]) => {
  const services = useServices();

  useEffect(() => {
    services.breadcrumbs.setBreadcrumbs(breadcrumbs);
  }, [services.breadcrumbs, breadcrumbs]);

  useEffect(() => {
    return () => {
      services.breadcrumbs.setBreadcrumbs([]);
    };
  }, [services.breadcrumbs]);
};
